export const Experiment = {
  OttaCues: "20220720_OTTACUES",
  AllSalaryBenchmarks: "20240708_SEARCH_APP_ALL_SALARY_BENCHMARKS",
  NewNotificationSettings: "20230621_NOTIFICATION_SETTINGS",
  CVUpload: "20230726_CV_UPLOAD",
  CompanyPodcast: "20240805_COMPANY_PODCAST",
  CurrentAddress: "20250331_CURRENT_ADDRESS",
  CVSignup: "20250728_CV_SIGNUP",
  MessagingWarning: "20260330_SEARCH_APP_MESSAGING_WARNING",
  MessagingDisabled: "20260330_SEARCH_APP_MESSAGING_DISABLED",
  DisplayStaticPage: "20260625_SEARCH_APP_REDIRECT_TO_STATIC_PAGE",
  RedirectNewUsers: "20260909_WEB_REDIRECT_NEW_USERS",
} as const;
